import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, claimViewModel) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
        $scope.claimVm.lobs.homeowners.propertyWaterDamage.value = $scope.claimVm.lobs.homeowners.propertyWaterDamage.value || {
            isRoofProtected: true,
            hasWaterBeenTurnedOff: true
        };
        $scope.damageTypes = {
            'waterdamage': _.findWhere($scope.claimVm.lossCause.aspects.availableValues, {
                code: 'waterdamage'
            }),
            'mold': _.findWhere($scope.claimVm.lossCause.aspects.availableValues, {
                code: 'mold'
            })
        };
        $scope.claimVm.lossCause.value = $scope.claimVm.lossCause.value || $scope.damageTypes.waterdamage;

        $scope.sourceTypes = {
            'plumbing_appliances': _.find($scope.claimVm.lobs.homeowners.propertyWaterDamage.waterSource.aspects.availableValues, {
                code: 'plumbing_appliances'
            }),
            'roof': _.find($scope.claimVm.lobs.homeowners.propertyWaterDamage.waterSource.aspects.availableValues, {
                code: 'roof'
            }),
            'other': _.find($scope.claimVm.lobs.homeowners.propertyWaterDamage.waterSource.aspects.availableValues, {
                code: 'other'
            })
        };

        $scope.claimVm.lobs.homeowners.propertyWaterDamage.waterSource.value = $scope.claimVm.lobs.homeowners.propertyWaterDamage.waterSource.value || $scope.sourceTypes.plumbing_appliances;
    };

    return ctrl.create($scope);
};

fn.$inject = ['$scope', 'claimViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ho/controllers/HOWaterDetailsCtrl.js
// module id = 1552
// module chunks = 0